import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWallet2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWallet2"><Path d="M21.5 10.5V19.5H2.5V10.5M21.5 10.5H19.5M21.5 10.5V4.5H2.5V10.5M2.5 10.5H4.5M4.5 10.5H8L10 12.5H14L16 10.5H19.5M4.5 10.5V7.5C4.5 6.94772 4.94772 6.5 5.5 6.5H18.5C19.0523 6.5 19.5 6.94772 19.5 7.5V10.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconWallet2;
